import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { appFeature } from '@access-request-unicorn/state/app.reducer';
import { PersonalInfo } from '@access-request-unicorn/models/personal-info.model';

export const CanActivateSummary: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(appFeature.selectPersonalInfo).pipe(
    map(info => !PersonalInfo.isNullPersonalInfo(info) || router.createUrlTree(['personal-info']))
  );
}
